const HttpMethods = {
	GET: 'GET',
	POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
	DELETE: 'DELETE'
};

export default HttpMethods;
